import {
  faArrowRightFromBracket,
  faChartSimple,
  faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRow,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "./video.scss";
import { useEffect, useState } from "react";
import Glide from "@glidejs/glide";
import coffeeTools from "../../CoffeeTools";
import lnbp_logo from "../../icon/icon.png";
import video_play_icon from "../../icon/8_B_Video.png";

const Video: React.FC<{
  video: { name; description; url; full_url_thumbnail; created_at; id };
}> = ({ video }) => {
  //   const [showProgessBar, setShowProgessBar] = useState(true);
  let base_url = process.env.REACT_APP_BASE_URL;
  let coffee_tools = new coffeeTools();

  //declared outside to make it global and used it on the page

  useEffect(() => {
    // show slider
    //start the page
    mainController.init();
    let coffee = new coffeeTools();
    // console.log(coffee.test(123));
  }, []);

  var controller = (() => {
    return {};
  })();

  let view = (() => {
    let dom_obj = {};

    // tools and helpers
    function createSectionTitles(title, dom_obj_id) {
      let container = document.getElementById(dom_obj_id);
      container.innerHTML = "";
      coffee_tools.createSectionTitle(title, container);
    }

    return {
      createSectionTitles: (title, container) =>
        createSectionTitles(title, container)
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        console.log("video component started");
        setupEventListeners();

        // setShowProgessBar(false);
      }
    };
  })(controller, view);

  return (
    <a href={video.url}>
      <div className='video_container'>
        <img
          className='video_play_icon'
          src={video_play_icon}
          alt='Play icon'
        />
        <img
          className='video_thumbnail'
          src={base_url + "/" + video.full_url_thumbnail}
          alt='Video del partido'
        />
        <div className='video_title'>
          {video.name}
          <br />
          <hr className='video_title_line' />
          <br />
          <span className='video_date'>
            {video.created_at?.substring(0, 10)}
          </span>
        </div>
      </div>
    </a>
  );
};

export default Video;
